<template>
  <div>
    <h2>Upload login data</h2>
    <ion-label>Vil du opdatere login data?</ion-label>
    <br />
    <input
      type="file"
      id="fileInput"
      ref="file"
      accept=".csv"
      @change="fileReader()"
    />
    <hr />
    {{ data.length }} / {{ csvArray.length }}

    <hr />
    <div v-if="fileDone">
      <ion-button expand="block" @click="saveLoginData()">Gem data</ion-button>
    </div>
    <br />
    <ion-label color="primary" v-if="loginMessage.length > 0">{{
      loginMessage
    }}</ion-label>
  </div>
</template>

<script>
import Papa from "papaparse";

import { mapGetters } from "vuex";
import { IonButton, IonLabel } from "@ionic/vue";

export default {
  components: {
    IonButton,
    IonLabel,
  },
  data() {
    return {
      fileDone: false,
      fileName: "",
      csvArray: [],
      data: [],
      loginMessage: "",
    };
  },
  computed: {
    ...mapGetters([]),
  },
  methods: {
    saveLoginData() {
      var app = this;
      if (this.data.length === 0) {
        this.loginMessage =
          "Filen mangler data eller kolonnen 'Login' - intet er gemt, eksisterende login data er uændret.";
        return;
      }
      this.$store.commit("saveLoginData", this.data);

      var result = this.$store.dispatch("saveToBlobStorage", {
        data: this.data,
        blobName: "login",
      });

      result.then(function(data) {
        app.loginMessage = data;
      });
    },
    fileReader() {
      var app = this;
      this.message = "Loading";
      this.loading = true;
      var oFile = this.$refs.file.files[0];

      //reset
      this.data = [];
      this.csvArray = [];
      this.fileDone = false;
      this.loginMessage = "";

      Papa.parse(oFile, {
        header: true,
        download: true,
        dynamicTyping: true,
        encoding: "UTF-8",
        skipEmptyLines: "greedy",
        transformHeader: (h) => h.replace(/^\ufeff/, ""),
        complete: function(results) {
          app.csvArray = results.data;

          // Rækker uden Login (fx tomme rækker i bunden af Excel-filen) ignoreres
          app.data = app.csvArray.filter((x) => x.Login);
          app.fileDone = app.data.length > 0;
        },
      });
    },
  },
};
</script>
